module.exports = __webpack_public_path__ + "img/sku-popup-bg.2f67c67.jpg";